import axios from "@/axios.js"
import moment from 'moment';


function createFilterSql(mapper, key, item) {
  if (item.operator) {      

    let all_conditions = []
    item.conditions.map((condition) => {
      var cond = mapper(key, condition);
      all_conditions.push(cond + " " + item.operator)
    });

    let final_condtion = all_conditions.join(' ')
    // remove last operator
    final_condtion = final_condtion.substring(0, final_condtion.lastIndexOf(" "));
    return "(" + final_condtion + ")";

  }else{

    return mapper(key, item);

  }  

  

}

function textFilterMapperGetAllOps(key, item) {

  if(key == 'contact_name'){
    key = 'cont.forename'
  }





  switch (item.type) {
    case "equals":
      return key + " = '" + item.filter + "'";
    case "notEqual":
      return key + "' != '" + item.filter + "'" + " OR " + key + " IS NULL";
    case "contains":
      return key + " ILIKE '%" + item.filter + "%'";
    case "notContains":
      return key + " NOT ILIKE '%" + item.filter + "%'" + " OR " + key + " IS NULL";
    case "startsWith":
      return key + " ILIKE '" + item.filter + "%'";
    case "endsWith":
      return key + " ILIKE '%" + item.filter + "'";
    case "blank":
      return "(" + key + " is NULL or " + key + " = '')";
    case "notBlank":
        return "(" + key + " is not NULL and " + key + " != '')";
    default:
      console.log("unknown text filter type: " + item.type);
  }
}

function textFilterMapper(key, item) {
  if(key == 'type'){
    key = 'f_v.type'
  }

  if(key == 'campaign_name'){
    key = 'c.campaign_name'
  }
  

  if(key == 'contact_full_name'){
    key = 'c.forename'
  }

  if(key == 'camp_name'){
    key = 'c.campaign_name'
  }

  if(key == 'campaign_status'){
    key = 'c_s.campaign_status'
  }








  switch (item.type) {
    case "equals":
      return key + " = '" + item.filter + "'";
    case "notEqual":
      return key + "' != '" + item.filter + "' OR " + key + " IS NULL";
    case "contains":
      return key + " ILIKE '%" + item.filter + "%'";
    case "notContains":
      return key + " NOT ILIKE '%" + item.filter + "%'" + " OR " + key + " IS NULL";
    case "startsWith":
      return key + " ILIKE '" + item.filter + "%'";
    case "endsWith":
      return key + " ILIKE '%" + item.filter + "'";
    case "blank":
        let empty_value1 = '[""]'
        return "(" + key + " is NULL or " + key + " = '' or " + key + " = '" + empty_value1 + "')";
    case "notBlank":
      let empty_value = '[""]'
      return "(" + key + " is not NULL and " + key + " != '' and " + key + " != '" + empty_value + "')";
    default:
      console.log("unknown text filter type: " + item.type);
  }
}


function OpportunitiesDateFilterMapper(key, item) {

  if(key == 'created_at'){
    key = 'op.created_at'
  }

  const myFormat= 'YYYY-MM-DD';
  item.dateFrom = moment(item.dateFrom).format(myFormat);
  item.dateTo = moment(item.dateTo).format(myFormat);


  switch (item.type) {
    case "equals":
      let option1 =  key + " = '" + item.dateFrom + "'";
      let option2 =   key +  " = '" + '["' + item.dateFrom + '"]' + "'";
      return "(" + option1 + " or " + option2 + ")";
    case "notEqual":
      let option3 =  key + " != '" + item.dateFrom + "' OR " + key + " IS NULL";
      let option4 =   key +  " != '" + '["' + item.dateFrom + '"]' + "' OR " + key + " IS NULL";
      return "(" + option3 + " or " + option4 + ")";
    case "greaterThan":
      return key + " > '" + item.dateFrom + "'";
    case "greaterThanOrEqual":
      return key + " >= '" + item.dateFrom + "'";
    case "lessThan":
      return key + " < '" + item.dateFrom + "' OR " + key + " IS NULL";
    case "lessThanOrEqual":
      return key + " <= '" + item.dateFrom + "'";
    case "blank":
      return "(" + key + " is NULL )"
    case "notBlank":
        return "(" + key + " is not NULL )"
    case "inRange":
      return (
        "(" +
        key +
        " >= '" +
        item.dateFrom +
        "' and " +
        key +
        " <= '" +
        item.dateTo +
        "')"
      );
    default:
      console.log("unknown number filter type: " + item.type);
  }
}



function dateFilterMapper(key, item) {
  switch (item.type) {
    case "equals":
      return key + " = '" + item.dateFrom + "'";
    case "notEqual":
      return key + " != '" + item.dateFrom + "' OR " + key + " IS NULL";
    case "greaterThan":
      return key + " > '" + item.dateFrom + "'";
    case "greaterThanOrEqual":
      return key + " >= '" + item.dateFrom + "'";
    case "lessThan":
      return key + " < '" + item.dateFrom + "' OR " + key + " IS NULL";
    case "lessThanOrEqual":
      return key + " <= '" + item.dateFrom + "'";
      case "blank":
      return "(" + key + " is NULL or " + key + " = '')";
    case "notBlank":
        return "(" + key + " is not NULL and " + key + " != '')";
     case "inRange":
      return (
        "(" +
        key +
        " >= '" +
        item.dateFrom +
        "' and " +
        key +
        " <= '" +
        item.dateTo +
        "')"
      );
    default:
      console.log("unknown number filter type: " + item.type);
  }
}

function numberFilterMapper(key, item) {
  switch (item.type) {
    case "equals":
      return key + " = " + item.filter;
    case "notEqual":
      return key + " != " + item.filter + " OR " + key + " IS NULL";
    case "greaterThan":
      return key + " > " + item.filter;
    case "greaterThanOrEqual":
      return key + " >= " + item.filter;
    case "lessThan":
      return key + " < " + item.filter + " OR " + key + " IS NULL";
    case "lessThanOrEqual":
      return key + " <= " + item.filter;
      case "blank":
        return key + " is NULL";
      case "notBlank":
        return key + " is not NULL";
    case "inRange":
      return (
        "(" +
        key +
        " >= " +
        item.filter +
        " and " +
        key +
        " <= " +
        item.filterTo +
        ")"
      );
    default:
      console.log("unknown number filter type: " + item.type);
  }
}

export default {
  getAllPurchaseOrderForGrid(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_all_purchase_order_for_grid');
    // console.log(SQL)

    axios.post("/api/campaigns/get_all_purchase_order_for_grid", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getClientOpportunities(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_client_opportunities');
    console.log(SQL)

    axios.post("/api/campaigns/get_client_opportunities", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getSDOpportunities(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_sd_opportunities');
    console.log(SQL)

    axios.post("/api/campaigns/get_sd_opportunities", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getAllOpportunityAlerts(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_all_opportunity_alerts');
    console.log(SQL)

    axios.post("/api/campaigns/get_all_opportunity_alerts", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getAllDocsTemplate(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_all_docs_template');
    // console.log(SQL)

    axios.post("/api/campaigns/get_all_docs_template", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getAllImageUpload(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_all_image_upload');
    // console.log(SQL)

    axios.post("/api/campaigns/get_all_image_upload", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getAllEmailTemplate(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_all_email_template');
    // console.log(SQL)

    axios.post("/api/campaigns/get_all_email_template", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getAllCampaignGradeCategories(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_all_campaign_grade_category');
    // console.log(SQL)

    axios.post("/api/campaigns/get_all_campaign_grade_category", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getAllCampaignsForGrid(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_all_campaigns_for_grid');
    // console.log(SQL)

    axios.post("/api/campaigns/get_all_campaigns_for_grid", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getAllCampaignsCascadingFieldsForGrid(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_all_campaigns_for_grid_for_cascading_fields');
    // console.log(SQL)

    axios.post("/api/campaigns/get_all_campaigns_for_grid_for_cascading_fields", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getAllCampaignsForGridForSelectedFields(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_all_campaigns_for_grid_for_selected_fields');
    console.log(SQL)

    axios.post("/api/campaigns/get_all_campaigns_for_grid_for_selected_fields", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getAllCampaignsForGridForPopulateData(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_all_campaigns_for_grid_for_populate_data');
    // console.log(SQL)

    axios.post("/api/campaigns/get_all_campaigns_for_grid_for_populate_data", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getAllCampaignsForReviewCampaignResultsGrid(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_all_campaigns_for_review_campaign_result_grid');
    console.log(SQL)

    axios.post("/api/campaigns/get_all_campaigns_for_review_campaign_result_grid", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getSalesDeveloperHistoricCampaignsForGrid(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_sales_developer_historic_campaigns_for_grid');
    // console.log(SQL)

    axios.post("/api/campaigns/get_sales_developer_historic_campaigns_for_grid", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getSalesDeveloperLiveCampaignsForGrid(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_sales_developer_live_campaigns_for_grid');
    console.log(SQL)

    axios.post("/api/campaigns/get_sales_developer_live_campaigns_for_grid", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getCampaignsForClient(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_campaigns_for_client');
    console.log(SQL)

    axios.post("/api/campaigns/get_campaigns_for_client", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getAdminClientViewCampaignDataSource(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_campaigns_for_admin_client_view');
    console.log(SQL)

    axios.post("/api/campaigns/get_campaigns_for_admin_client_view", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getAdminClientAndUserViewCampaignDataSource(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_campaigns_for_admin_client_and_user_view');
    console.log(SQL)

    axios.post("/api/campaigns/get_campaigns_for_admin_client_and_user_view", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getDefaultViewDataSource(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_default_view_data_source');
    console.log(SQL)

    axios.post("/api/campaigns/get_default_view_data_source", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getdefaultOpportunitiesViewDataSource(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_default_opportunities_view_data_source');
    console.log(SQL)

    axios.post("/api/campaigns/get_default_opportunities_view_data_source", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  buildSql(request, method) {
    let selectSql;
    let fromSql;
    if (method == 'get_all_purchase_order_for_grid') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM purchase_orders po left join clients c on c.uuid = po.client_id ";
    }
    if (method == 'get_client_opportunities') {
      selectSql = this.selectSql(request, method);
      if (request.selected_campaign_id != null) {
        let table_name = 'client_view_opportunity_' + request.selected_campaign_id.replaceAll("-", "_")
        fromSql = " FROM " + table_name + " op left join accounts a on a.uuid = op.account_id left join contacts c on c.uuid = op.contact_id";
      }
    }
    if (method == 'get_sd_opportunities') {
      selectSql = this.selectSql(request, method);
      if (request.selected_campaign_id != null) {
        let table_name = 'sd_qc_opportunity_' + request.selected_campaign_id.replaceAll("-", "_")
        fromSql = " FROM " + table_name + " op left join accounts a on a.uuid = op.account_id left join contacts c on c.uuid = op.contact_id";
      }
    }
    if (method == 'get_all_opportunity_alerts') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM opportunity_alerts oa inner join campaigns c on c.uuid = oa.campaign_id inner join accounts a on a.uuid = oa.account_id inner join contacts cont on cont.uuid = oa.contact_id";
    }
    if (method == 'get_all_email_template') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM email_template";
    }
    if (method == 'get_all_docs_template') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM docs_template";
    }
    if (method == 'get_all_image_upload') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM upload_image";
    }
    if (method == 'get_all_campaign_grade_category') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM campaigns c inner join campaign_grade_category cuo on c.uuid = cuo.campaign_id";
    }
    if (method == 'get_all_campaigns') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM campaigns ";
    }
    if (method == 'get_all_campaigns_for_grid') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM campaigns c inner join client_campaign_association cca on c.uuid = cca.campaign_id inner join clients cl on cl.uuid = cca.client_id";
    }
    if (method == 'get_all_campaigns_for_grid_for_cascading_fields') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM campaigns c inner join cascade_fields cf on c.uuid = cf.campaign_id";
    }
    if (method == 'get_campaigns_for_client') {
      selectSql = this.selectSql(request, method);
      fromSql = ' FROM campaigns c inner join user_campaign_association uca on c.uuid = uca.campaign_id inner join "user" u on u.uuid = uca.user_id inner join campaign_status c_s on c.campaign_status = c_s.uuid';
    }
    if (method == 'get_campaigns_for_admin_client_view') {
      selectSql = this.selectSql(request, method);
      fromSql = ' FROM campaigns c inner join client_campaign_association cca on cca.campaign_id  = c.uuid inner join campaign_status c_s on c.campaign_status = c_s.uuid';
    }
    if (method == 'get_campaigns_for_admin_client_and_user_view') {
      selectSql = this.selectSql(request, method);
      fromSql = ' FROM campaigns c inner join user_campaign_association uca on c.uuid = uca.campaign_id inner join "user" u on u.uuid = uca.user_id inner join client_campaign_association cca on cca.campaign_id  = c.uuid inner join campaign_status c_s on c.campaign_status = c_s.uuid';
    }
    if (method == 'get_default_view_data_source') {
      selectSql = this.selectSql(request, method);
      fromSql = ' FROM client_user_saved_view cusv inner join client_user_saved_view_users cusvu on cusv.uuid = cusvu.client_user_saved_view_id';
    }
    if (method == 'get_default_opportunities_view_data_source') {
      selectSql = this.selectSql(request, method);
      fromSql = ' FROM client_user_opportunities_saved_view cusv inner join client_user_opportunities_saved_view_users cusvu on cusv.uuid = cusvu.client_user_saved_view_id';
    }
    if (method == 'get_all_campaigns_for_grid_for_selected_fields') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM campaigns c inner join campaign_status c_s on c.campaign_status = c_s.uuid";
    }
    if (method == 'get_all_campaigns_for_grid_for_populate_data') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM campaigns c inner join campaign_status c_s on c.campaign_status = c_s.uuid";
    }
    if (method == 'get_all_campaigns_for_review_campaign_result_grid') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM campaigns c inner join client_campaign_association cca on c.uuid = cca.campaign_id inner join campaign_status c_s on c.campaign_status = c_s.uuid";
    }
    if (method == 'get_sales_developer_historic_campaigns_for_grid') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM campaigns c inner join campaign_status c_s on c.campaign_status = c_s.uuid inner join campaign_sales_developer csd on csd.campaign_id = c.uuid";
    }
    if (method == 'get_sales_developer_live_campaigns_for_grid') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM campaigns c inner join campaign_status c_s on c.campaign_status = c_s.uuid inner join campaign_sales_developer csd on csd.campaign_id = c.uuid";
    }
    const whereSql = this.whereSql(request, method);
    const limitSql = this.limitSql(request);
    const orderBySql = this.orderBySql(request,method);
    const groupBySql = this.groupBySql(request);

    return selectSql + fromSql + whereSql + groupBySql + orderBySql + limitSql;
  },
  groupBySql(request) {
    var rowGroupCols = request.rowGroupCols;
    var groupKeys = request.groupKeys;

    if (this.isDoingGrouping(rowGroupCols, groupKeys)) {
      var rowGroupCol = rowGroupCols[groupKeys.length];

      return " GROUP BY " + rowGroupCol.id;
    }

    return "";
  },
  getRowCount(request, results) {
    if (results === null || results === undefined || results.length === 0) {
      return null;
    }
    const currentLastRow = request.startRow + results.length;
    return currentLastRow <= request.endRow ? currentLastRow : -1;
  },

  cutResultsToPageSize(request, results) {
    const pageSize = request.endRow - request.startRow;
    if (results && results.length > pageSize) {
      return results.splice(0, pageSize);
    } else {
      return results;
    }
  },
  selectSql(request, method) {


    var rowGroupCols = request.rowGroupCols;
    var valueCols = request.valueCols;
    var groupKeys = request.groupKeys;

    if (this.isDoingGrouping(rowGroupCols, groupKeys)) {
      var rowGroupCol = rowGroupCols[groupKeys.length];
      var colsToSelect = [rowGroupCol.id];

      valueCols.forEach(function (valueCol) {
        colsToSelect.push(
          valueCol.aggFunc + "(" + valueCol.id + ") AS " + valueCol.id
        );
      });

      return "SELECT " + colsToSelect.join(", ");
    } else if (method == 'get_all_campaigns') {
      return `SELECT *`;
    
  } 
  else if (method == 'get_all_campaigns_for_grid') {
  return `SELECT DISTINCT *`;

}
else if (method == 'get_all_campaigns_for_grid_for_cascading_fields') {
  return `SELECT DISTINCT *`;

}
else if (method == 'get_all_campaign_grade_category') {
  return `SELECT DISTINCT *`;

}
else if (method == 'get_all_docs_template') {
  return `SELECT DISTINCT *`;

}
else if (method == 'get_all_image_upload') {
  return `SELECT DISTINCT *`;

}
else if (method == 'get_all_email_template') {
  return `SELECT DISTINCT *`;

}
else if (method == 'get_all_opportunity_alerts') {
  return `SELECT DISTINCT *, oa.uuid as opportunity_alert_id`;
}
else if (method == 'get_client_opportunities') {
  return `SELECT DISTINCT * ,op.uuid as sd_opportunity_id, CONCAT(c.forename, ' ' , c.surname) as contact_full_name `;
}
else if (method == 'get_sd_opportunities') {
  return `SELECT DISTINCT * ,op.uuid as sd_opportunity_id, CONCAT(c.forename, ' ' , c.surname) as contact_full_name `;
}
else if (method == 'get_all_purchase_order_for_grid') {
  return `SELECT DISTINCT * , po.uuid as po_id `;
}
else if (method == 'get_campaigns_for_client') {
  return `SELECT DISTINCT *`;

}
else if (method == 'get_campaigns_for_admin_client_view') {
  return `SELECT DISTINCT *`;

}
else if (method == 'get_campaigns_for_admin_client_and_user_view') {
  return `SELECT DISTINCT *`;

}
else if (method == 'get_default_view_data_source') {
  return `SELECT DISTINCT cusv.*`;

}
else if (method == 'get_default_opportunities_view_data_source') {
  return `SELECT DISTINCT cusv.*`;

}
else if (method == 'get_all_campaigns_for_grid_for_populate_data') {
  return `SELECT distinct *,c.uuid as campaign_id,c.campaign_name as camp_name`;

}
else if (method == 'get_all_campaigns_for_grid_for_selected_fields') {
  return `SELECT *, c.uuid as campaign_id,c.campaign_name as camp_name`;

}
else if (method == 'get_all_campaigns_for_review_campaign_result_grid') {
  return `SELECT distinct *,c.uuid as campaign_id,c.campaign_name as camp_name`;

} else if (method == 'get_sales_developer_historic_campaigns_for_grid') {
    return `SELECT distinct *,c.uuid as campaign_id`;
  } 
  else if (method == 'get_sales_developer_live_campaigns_for_grid') {
    return `SELECT distinct *,c.uuid as campaign_id`;
  }
  else {
      return "SELECT distinct a.*";
    }

  },
  whereSql(request, method) {
    var whereParts = [];
    var filterModel = request.filterModel;
    if (method == 'get_sales_developer_historic_campaigns_for_grid') {
      whereParts.push("csd.sales_developer_id = '" + request.sales_developer_id + "'")
      whereParts.push("c_s.campaign_status = 'Completed'")
      // whereParts.push("tct.type = 'accounts'")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_sales_developer_live_campaigns_for_grid') {
      whereParts.push("csd.sales_developer_id = '" + request.sales_developer_id + "'")
      whereParts.push("c_s.campaign_status = 'Live'")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }
  
    }
    else if (method == 'get_all_campaigns_for_grid') {

      if (request.selected_autocomplete_campaign != undefined) {
        whereParts.push("cca.campaign_id = '" + request.selected_autocomplete_campaign.campaign_id + "'")
      }
      whereParts.push("cca.primary is True")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_all_campaigns_for_grid_for_cascading_fields') {
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_all_campaign_grade_category') {
      if (request.campaign_id != undefined) {
        whereParts.push("c.uuid = '" + request.campaign_id + "'")
      }
      whereParts.push("cuo.deleted != True")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_all_docs_template') {
      whereParts.push("deleted = 'False'")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }
    }
    else if (method == 'get_all_image_upload') {
      whereParts.push("deleted = 'False'")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_all_email_template') {
      whereParts.push("deleted = 'False'")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_client_opportunities') {
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(OpportunitiesDateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }
    }
    else if (method == 'get_sd_opportunities') {

      // if (request.sales_developer_id != undefined) {
      //   whereParts.push("op.sales_developer_id = '" + request.sales_developer_id + "'")
      // }

      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(OpportunitiesDateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }
    }
    else if (method == 'get_campaigns_for_client') {

      if (request.client_id != undefined) {
        whereParts.push("u.uuid = '" + request.client_id + "'")
      }

      if (request.campaign_status != 'All') {
        whereParts.push("c_s.campaign_status = '" + request.campaign_status + "'")
      }


      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }

    else if (method == 'get_campaigns_for_admin_client_view') {

      if (request.client_id != undefined) {
        whereParts.push("cca.client_id = '" + request.client_id + "'")
      }

      if (request.campaign_status != 'All') {
        whereParts.push("c_s.campaign_status = '" + request.campaign_status + "'")
      }


      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }

    else if (method == 'get_campaigns_for_admin_client_and_user_view') {

      if (request.client_id != undefined) {
        whereParts.push("cca.client_id = '" + request.client_id + "'")
      }

      if (request.client_user_id != undefined) {
        whereParts.push("u.uuid = '" + request.client_user_id + "'")
      }

      if (request.campaign_status != 'All') {
        whereParts.push("c_s.campaign_status = '" + request.campaign_status + "'")
      }


      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_default_view_data_source') {

  

      if (request.selected_campaign != undefined) {
        whereParts.push(" cusv.campaign_id = '" + request.selected_campaign + "'")
      }



      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_default_opportunities_view_data_source') {

  

      if (request.selected_campaign != undefined) {
        whereParts.push(" cusv.campaign_id = '" + request.selected_campaign + "'")
      }



      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_all_purchase_order_for_grid') {

        whereParts.push("po.deleted = False")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_all_campaigns_for_grid_for_populate_data') {
      whereParts.push("c.deleted = False")
      // whereParts.push("c.campaign_status = 'd226b575-40eb-4919-a7b9-5fb02808ef2d'")

      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_all_campaigns_for_grid_for_selected_fields') {
      whereParts.push("c.deleted = False")

      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_all_campaigns_for_review_campaign_result_grid') {
      if (request.selected_autocomplete_campaign != undefined) {
        whereParts.push("cca.campaign_id = '" + request.selected_autocomplete_campaign.campaign_id + "'")
      }

      whereParts.push("cca.primary = 'True'")

      // whereParts.push("cca.primary is True")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_all_campaigns') {
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    } 
    else if (method == 'get_all_opportunity_alerts') {
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapperGetAllOps, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }else {
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {

          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }
    }


    if (whereParts.length > 0) {
      return " WHERE " + whereParts.join(" AND ");
    }

    return "";
  },
  isDoingGrouping(rowGroupCols, groupKeys) {
    // we are not doing grouping if at the lowest level
    return rowGroupCols.length > groupKeys.length;
  },
  orderBySql(request,method) {


   


    var sortModel = request.sortModel;
    if (method == 'get_all_master_fields') {
      if (sortModel.length === 0) return " ORDER BY m_f.created_at DESC";
    }else{
      if (sortModel.length === 0) return "";
    }

    var sorts = sortModel.map(function (s) {

        if (s.colId == 'campaign_status') {
          s.colId = 'c_s.campaign_status'
        }
        


  
      return s.colId + " " + s.sort.toUpperCase();
    });

    return " ORDER BY " + sorts.join(", ") + " NULLS LAST ";
  },
  limitSql(request) {
    var blockSize = request.endRow - request.startRow;

    return " LIMIT " + (blockSize + 1) + " OFFSET " + request.startRow;
  },
  getLastRowIndex(request, results) {
    if (!results || results.length === 0) {
      return request.startRow;
    }

    var currentLastRow = request.startRow + results.length;

    return currentLastRow <= request.endRow ? currentLastRow : -1;
  }

  // helper methods ...
};